import { render } from "./qxc-q5.vue?vue&type=template&id=b33f4566&scoped=true"
import script from "./qxc-q5.vue?vue&type=script&lang=js"
export * from "./qxc-q5.vue?vue&type=script&lang=js"

import "./qxc-q5.vue?vue&type=style&index=0&id=b33f4566&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b33f4566"]])

export default __exports__